import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityReport4det } from "../../entity/EntityReport4det";
import { EntityReport } from "../../entity/EntityReport";
import { EntityReportDet } from "../../entity/EntityReportDet";

export class DtoReport4detsGetRes extends EntityReport4det {
  public items: EntityReport4det[] = [];
}

